import { Slider, Switch } from '@mui/material';
import StringSelector from './widgets/StringSelector';
import StringMultiSelector from './widgets/StringMultiSelector';
import DateSelector from './widgets/DateSelector';
import SimpleDateSelector from './widgets/SimpleDateSelector';
import format from 'format-duration';
import BlockIcon from '@mui/icons-material/Block';

const timedelta = {
    SECOND: 1000,
    MINUTE: 60 * 1000,
    HOUR: 60 * 60 * 1000,
    DAY: 24 * 60 * 60 * 1000,
    WEEK: 7 * 24 * 60 * 60 * 1000,
    MONTH: 28 * 24 * 60 * 60 * 1000,
    YEAR: 365 * 24 * 60 * 60 * 1000,
};

/**
 * @deprecated Use react-hook-form-mui instead
 */
const type2component = [
    {
        component: (key, value, setOption, extraProps) => (
            <Switch checked={value} onChange={(e) => setOption(key, e.target.checked)} {...extraProps} />
        ),
    },
    {
        component: (key, value, setOption, { timeSlider = false, ...extraProps }) => (
            <Slider
                value={value}
                onChange={(e, v) => setOption(key, v)}
                {...extraProps}
                valueLabelDisplay='auto'
                valueLabelFormat={timeSlider ? (v) => format(v, { leading: true }) : (v) => v}
            />
        ),
    },
    {
        component: (key, value, setOption, extraProps) => (
            <StringSelector value={value} onChange={(v) => setOption(key, v)} {...extraProps} />
        ),
    },
    {
        component: (key, value, setOption, extraProps) => (
            <StringMultiSelector value={value} onChange={(v) => setOption(key, v)} {...extraProps} />
        ),
    },
    {
        component: (key, value, setOption, extraProps) => (
            <DateSelector value={value} onChange={(v) => setOption(key, v)} {...extraProps} />
        ),
    },
    {
        component: (key, value, setOption, extraProps) => (
            <SimpleDateSelector value={value} onChange={(v) => setOption(key, v)} {...extraProps} />
        ),
    },
    {
        component: () => <BlockIcon />,
    },
];

export { timedelta, type2component };
